import React from 'react';
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-react';
import { conditionRowGrid } from '../../utils/conditions';
import type { SortKey, SortState } from '../../types/conditions';
interface ConditionsTableHeaderProps {
  sort: SortState | null;
  onSort: (key: SortKey) => void;
  allSelected: boolean;
  someSelected: boolean;
  onToggleSelectAll: () => void;
}
const columns: {
  label: string;
  key: SortKey;
}[] = [{
  label: 'Condition',
  key: 'name'
}, {
  label: 'Status',
  key: 'status'
}, {
  label: 'Created',
  key: 'createdAt'
}, {
  label: 'Requested',
  key: 'requestedAt'
}, {
  label: 'ETA',
  key: 'eta'
}, {
  label: 'Owner',
  key: 'assignee'
}];
export function ConditionsTableHeader({
  sort,
  onSort,
  allSelected,
  someSelected,
  onToggleSelectAll
}: ConditionsTableHeaderProps) {
  return <div role="row" className={`${conditionRowGrid} border-b border-slate-200 px-6 py-2.5 text-xs text-slate-500`} data-id="element-200" data-mp="2rkqn603d6bnd">
      <div role="columnheader" data-id="element-201" data-mp="2ngiy21szutom">
        <input type="checkbox" checked={allSelected} ref={el => {
        if (el) el.indeterminate = someSelected && !allSelected;
      }} onChange={onToggleSelectAll} aria-label="Select all conditions" className="h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand" data-id="element-202" data-mp="tuphv2govrbj" />
      </div>
      {columns.map(({
      label,
      key
    }) => {
      const active = sort?.key === key;
      const SortIcon = !active ? ArrowUpDownIcon : sort.direction === 'asc' ? ArrowUpIcon : ArrowDownIcon;
      return <div key={key} role="columnheader" aria-sort={active ? sort.direction === 'asc' ? 'ascending' : 'descending' : 'none'} data-id="element-203" data-mp="1gsj15uxz2mim">
            <button type="button" onClick={() => onSort(key)} className={`group -mx-1 inline-flex items-center gap-1 rounded px-1 py-0.5 font-medium transition-colors hover:text-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${active ? 'text-brand' : ''}`} data-id="element-204" data-mp="1qjx7omoccml9">
              {label}
              <SortIcon className={`h-3 w-3 transition-opacity ${active ? 'opacity-100' : 'opacity-0 group-hover:opacity-60'}`} aria-hidden="true" data-id="element-205" data-mp="15xh18z9v79sx" />
            </button>
          </div>;
    })}
      <div role="columnheader" data-id="element-206" data-mp="1tkp5ddvk4ctd">
        <span className="sr-only" data-id="element-207" data-mp="1tjxdad164x7u">Actions</span>
      </div>
    </div>;
}